import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    locations: [],
    loading: false,
    error: null,
    selectedLocation: null
  },

  mutations: {
    SET_LOCATIONS(state, data) {
      // Handle both array and {items: []} formats
      state.locations = Array.isArray(data) ? data : (data?.items || [])
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SELECTED_LOCATION(state, location) {
      state.selectedLocation = location
    }
  },

  getters: {
    getLocations: state => state.locations || [],
    getSelectedLocation: state => state.selectedLocation,
    isLoading: state => state.loading,
    getError: state => state.error
  },

  actions: {
    async fetchLocation({ commit }, id) {
      try {
        const response = await axios.get(`/attendance/locations/${id}`)
        const data = {
          ...response.data,
          personnel: Array.isArray(response.data.personnel) ? response.data.personnel : []
        }
        commit('SET_SELECTED_LOCATION', data)
        return data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Có lỗi xảy ra')
        throw error
      }
    },

    async fetchLocations({ commit }) {
      commit('SET_LOADING', true)
      try {
        const response = await axios.get('/attendance/locations')
        let locations = []
        
        if (Array.isArray(response.data)) {
          locations = response.data
        } else if (response.data && Array.isArray(response.data.items)) {
          locations = response.data.items
        }

        // Ensure personnel is always an array
        locations = locations.map(loc => ({
          ...loc,
          personnel: Array.isArray(loc.personnel) ? loc.personnel : []
        }))

        commit('SET_LOCATIONS', locations)
        return locations
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Có lỗi xảy ra')
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createLocation({ commit }, data) {
      try {
        const response = await axios.post('/attendance/locations', data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Có lỗi xảy ra')
        throw error
      }
    },

    async updateLocation({ commit }, { id, data }) {
      try {
        const response = await axios.put(`/attendance/locations/${id}`, data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Có lỗi xảy ra')
        throw error
      }
    },

    async deleteLocation({ commit }, id) {
      try {
        const response = await axios.delete(`/attendance/locations/${id}`)
        return response.data
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || 'Có lỗi xảy ra')
        throw error
      }
    }
  }
}